import { FeatureOption } from './feature-option';
import { Fragment } from './fragment';

export enum FragmentStatus {
    Available = 0,
    Planned = 1,
    PhaseOut = 2,
    Unplanned = 3,
    Disabled = 4,
}

export class IndustryFragment {
    level: number = 0;
    description: string;
    fragment: string;
    status: number;
    allowISO: string;
    denyISO: string;
    options: FeatureOption[];
    Group: string;
    ParentGroup: string;
    Childrens: IndustryFragment[];
    IsInIndustry: boolean = false;
    optionID: string;
    hasFlatPrice: boolean;
    incompatibilities: string;
    startvaliditydate: Date;
    endvaliditydate: Date;
    productid: string;

    public populate(f: Fragment) {
        this.allowISO = f.AllowISO;
        this.denyISO = f.DenyISO;
        this.status = f.Status;
        this.fragment = f.Fragment;
        this.description = f.Description;
        this.level = f.Level;
        this.Group = f.Group;
        this.options = [];
        this.options.push(new FeatureOption('STD', ''));
        this.options.push(new FeatureOption('PRM', ''));
        this.options.push(new FeatureOption('PRO', ''));
        this.options.push(new FeatureOption('ENT', ''));
        this.optionID = f.OptionID;
        this.hasFlatPrice = f.HasFlatPrice;
        this.incompatibilities = f.Incompatibilities;
        this.startvaliditydate = f.StartValidityDate;
        this.endvaliditydate = f.EndValidityDate;
        this.productid = f.ProductID;

        this.Childrens = [];
    }
}

export interface IIndustryFlatFragment {
    expandable: boolean;
    stateFragment: IndustryFragment;
    level: number;
}
